"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchField = SearchField;
const jsx_runtime_1 = require("react/jsx-runtime");
const js_1 = require("@mdi/js");
const field_1 = require("./field");
const icon_1 = require("./icon");
const input_1 = require("./input");
const label_1 = require("./label");
function SearchField({ value, onValueChange, label, clearLabel, placeholder, className, ref, ...rest }) {
    return ((0, jsx_runtime_1.jsxs)(field_1.Field, { className: className, children: [(0, jsx_runtime_1.jsx)(label_1.Label, { className: "ko:sr-only", children: label }), (0, jsx_runtime_1.jsx)(input_1.Input, { ...rest, ref: ref, type: "search", value: value, placeholder: placeholder, onChange: (event) => onValueChange(event.target.value), onClear: () => onValueChange(""), clearLabel: clearLabel, children: (0, jsx_runtime_1.jsx)(icon_1.Icon, { icon: js_1.mdiMagnify, decorative: true, size: "small" }) })] }));
}
